module.exports = __webpack_public_path__ + "img/8.60cc0d0f.png";